module.exports = __webpack_public_path__ + "img/socialRight.71fd7d3b.png";